module.exports = __webpack_public_path__ + "static/media/logo.827a1e2b.png";